// extracted by mini-css-extract-plugin
export default {"fullWidthTable":"TableStyles_fullWidthTable__G9bJj","rowWithBorder":"TableStyles_rowWithBorder__T0uhF","cellWithBorder":"TableStyles_cellWithBorder__RDcu3"};